"use client";

export function RangeSlider({
  min,
  max,
  value,
  onChange,
}: {
  min: number;
  max: number;
  value: number;
  onChange: (v: number) => void;
}) {
  return (
    <input
      type="range"
      className="range-track"
      min={min}
      max={max}
      step={max > 1000 ? 100000 : 1}
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
    />
  );
}

export function DualRange({
  min,
  max,
  low,
  high,
  onLowChange,
  onHighChange,
  format,
}: {
  min: number;
  max: number;
  low: number;
  high: number;
  onLowChange: (v: number) => void;
  onHighChange: (v: number) => void;
  format?: (v: number) => string;
}) {
  const fmt = format ?? ((v: number) => String(v));

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <RangeSlider min={min} max={max} value={low} onChange={(v) => onLowChange(Math.min(v, high))} />
        <RangeSlider min={min} max={max} value={high} onChange={(v) => onHighChange(Math.max(v, low))} />
      </div>
      <div className="flex items-center gap-2">
        <div className="flex-1 rounded-xl bg-[#f5f5f7] px-3 py-2 text-center text-sm font-semibold">
          {fmt(low)}
        </div>
        <span className="text-xs text-muted">–</span>
        <div className="flex-1 rounded-xl bg-[#f5f5f7] px-3 py-2 text-center text-sm font-semibold">
          {fmt(high)}
        </div>
      </div>
    </div>
  );
}
